import type { ICreatomateTemplateApiResponseModel } from '@/shared/models/creatomate/creatomate.model';
import { api } from '../../../shared/services/api/api';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

const baseUrl = 'creatomate';

interface ICreatomateResponse {
  templateData: ICreatomateTemplateApiResponseModel;
}

export const customerCreatomateApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCreatomateTemplates: build.query<ICreatomateResponse, { propertyExtId: string | null; companyId: string }>({
      async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
        const templateQuery = await fetchWithBQ({
          url: `${baseUrl}/templates`,
          method: 'GET',
        });

        return templateQuery.data
          ? {
              data: {
                templateData: templateQuery.data as ICreatomateTemplateApiResponseModel,
              },
            }
          : { error: templateQuery.error as FetchBaseQueryError };
      },
    }),
    createCreatomate: build.mutation({
      query: (val: any) => ({
        url: `${baseUrl}/videos/from-template`,
        method: 'POST',
        body: val,
      }),
    }),
  }),
});

export const { useCreateCreatomateMutation, useGetCreatomateTemplatesQuery } = customerCreatomateApi;
